<template>
  <div id="contenedor-fuentesfinancieras-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'FuentesfinancierasMain',
  data() {
    return {};
  },

};
</script>

<style lang="scss">

</style>
